module.exports = __webpack_public_path__ + "img/DE02658.5ae6d85f.png";